import React, { useState } from "react";
import { cn } from "../../lib/cn";

const SIZES = {
  xs: "h-7 w-7 text-[0.65rem]",
  sm: "h-9 w-9 text-xs",
  md: "h-8 w-8 text-xs",
  lg: "h-10 w-10 text-sm",
  xl: "h-20 w-20 text-xl",
};

function initials(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}

/** Image avatar with graceful initials fallback. */
export function Avatar({ src, name, size = "md", className }) {
  const [broken, setBroken] = useState(false);
  const showImg = src && !broken;
  return (
    <span
      className={cn(
        // text-onprimary, not text-white: in dark mode `primary` is the bright
        // brand green, and white initials on it measure ~1.6:1. The token flips
        // to dark text there and to white on the deep green in light mode.
        "relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-display font-semibold",
        !showImg && "bg-primary text-onprimary",
        SIZES[size],
        className
      )}
    >
      {showImg ? (
        <img src={src} alt={name || "avatar"} className="h-full w-full object-cover" onError={() => setBroken(true)} />
      ) : (
        initials(name)
      )}
    </span>
  );
}

export default Avatar;
